import React from 'react'
import {
  Ach,
  Affirm,
  Afterpay,
  Alfamart,
  Alipay,
  Amazon,
  AmazonTransparent,
  Amex,
  Applepay,
  AtmMomo,
  Aura,
  Bacs,
  Bancontact,
  Bankaxept,
  Bb,
  BbTransparent,
  Benefit,
  Bitcoin,
  Blik,
  Boleto,
  BoletoTransparent,
  Boost,
  Bradesco,
  BradescoTransparent,
  Caixa,
  CaixaTransparent,
  Carnet,
  CartesBancaires,
  Cielo,
  CieloTransparent,
  Cirrus,
  Clearpay,
  Dana,
  Dankort,
  Diners,
  DinersClub,
  DirectDebit,
  Discover,
  DokuWallet,
  Dotpay,
  Ebay,
  EftposAustralia,
  Elavon,
  ElavonTransparent,
  Elo,
  Eps,
  Eway,
  Fawry,
  GCash,
  Generic,
  GenericTransparent,
  Girocard,
  Giropay,
  Global,
  GlobalTransparent,
  Googlepay,
  GrabPay,
  Green,
  Hiper,
  Hsbc,
  HsbcTransparent,
  Ideal,
  InteracLogo,
  Itau,
  ItauTransparent,
  Jcb,
  KakaoPay,
  Klarna,
  Knet,
  Konbini,
  MPesa,
  Mada,
  Maestro,
  Mastercard,
  MbWay,
  Meeza,
  MobilePay,
  Multibanco,
  Naps,
  Omannet,
  Oxxo,
  Pagseguro,
  PagseguroTransparent,
  PayEasy,
  Payco,
  Paypal,
  PaypalTransparent,
  Paysafecard,
  Payshop,
  Paywithgoogle,
  Pix,
  Poli,
  Ratepay,
  RazerGold,
  Rede,
  RedeTransparent,
  Sage,
  SamsungPay,
  Santander,
  SantanderTransparent,
  Sepa,
  Shopify,
  Skrill,
  SkrillMoneybookers,
  Solo,
  Stone,
  StoneTransparent,
  Swish,
  Troy,
  Trustly,
  Twint,
  UnionPay,
  Vipps,
  Visa,
  VisaElectron,
  Visadankort,
  Vpay,
  Wallet,
  WalletTransparent,
  Wechatpay,
  Western,
  Worldpay,
  WorldpayTransparent,
} from 'react-pay-icons'

export const PAYMENT_METHOD_TYPES = {
  Ach,
  Affirm,
  Afterpay,
  Alfamart,
  Alipay,
  Amazon,
  AmazonTransparent,
  Amex,
  Applepay,
  AtmMomo,
  Aura,
  Bacs,
  Bancontact,
  Bankaxept,
  Bb,
  BbTransparent,
  Benefit,
  Bitcoin,
  Blik,
  Boleto,
  BoletoTransparent,
  Boost,
  Bradesco,
  BradescoTransparent,
  Caixa,
  CaixaTransparent,
  Carnet,
  CartesBancaires,
  Cielo,
  CieloTransparent,
  Cirrus,
  Clearpay,
  Dana,
  Dankort,
  Diners,
  DinersClub,
  DirectDebit,
  Discover,
  DokuWallet,
  Dotpay,
  Ebay,
  EftposAustralia,
  Elavon,
  ElavonTransparent,
  Elo,
  Eps,
  Eway,
  Fawry,
  GCash,
  Generic,
  GenericTransparent,
  Girocard,
  Giropay,
  Global,
  GlobalTransparent,
  Googlepay,
  GrabPay,
  Green,
  Hiper,
  Hsbc,
  HsbcTransparent,
  Ideal,
  InteracLogo,
  Itau,
  ItauTransparent,
  Jcb,
  KakaoPay,
  Klarna,
  Knet,
  Konbini,
  MPesa,
  Mada,
  Maestro,
  Mastercard,
  MbWay,
  Meeza,
  MobilePay,
  Multibanco,
  Naps,
  Omannet,
  Oxxo,
  Pagseguro,
  PagseguroTransparent,
  PayEasy,
  Payco,
  Paypal,
  PaypalTransparent,
  Paysafecard,
  Payshop,
  Paywithgoogle,
  Pix,
  Poli,
  Ratepay,
  RazerGold,
  Rede,
  RedeTransparent,
  Sage,
  SamsungPay,
  Santander,
  SantanderTransparent,
  Sepa,
  Shopify,
  Skrill,
  SkrillMoneybookers,
  Solo,
  Stone,
  StoneTransparent,
  Swish,
  Troy,
  Trustly,
  Twint,
  UnionPay,
  Vipps,
  Visa,
  VisaElectron,
  Visadankort,
  Vpay,
  Wallet,
  WalletTransparent,
  Wechatpay,
  Western,
  Worldpay,
  WorldpayTransparent,
}

export const getPaymentMethodTypeIcon = (keys = [], props) => {
  let Component = null
  keys.forEach(key => {
    if (PAYMENT_METHOD_TYPES[key]) {
      Component = PAYMENT_METHOD_TYPES[key]
      return
    }
  })

  return Component ? (
    <Component {...props} />
  ) : (
    <i className="fa fa-credit-card fa-2x" aria-hidden="true" {...props} />
  )
}
